<template>
  <section>
    <!-- <h2>[API]</h2> -->
    <!-- <pre>{{ $sv['application']['application_type'] }}</pre> -->
    <!-- <pre class="mt-3">{{ api }}</pre> -->
    <Demo />
    <StoreDemoViewer />
  </section>
</template>

<script>
////////////////////////////////////////
// Imported here to enable HMR
////////////////////////////////////////
import $store2 from './lib/store'

// Local components
import Demo from './components/Demo'
import StoreDemoViewer from './components/StoreDemoViewer'

export default {
  components: {
    Demo,
    StoreDemoViewer
  },
  props: ['api'],
  data() {
    return {
    }
  },
  computed: {
  },
  watch: {
  },
  created() {
  },
  mounted() {
  },
  updated() {
  },
  activated() {
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
// @import '@assets/sass/backend/_core-variables.scss';
</style>
